import { useLocation, Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";

export default function NotFound() {
  const location = useLocation();

  return (
    <Layout>
      <div className="flex flex-col items-center justify-center text-center px-4 pt-32 pb-24">
        <div className="relative mb-8">
          <div className="text-8xl md:text-9xl font-heading text-primary-100 select-none">404</div>
        </div>
        <div className="relative z-10 max-w-md">
          <h1 className="text-xl md:text-2xl font-heading text-foreground-900 mb-2">
            页面未找到
          </h1>
          <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
          <p className="mt-4 text-sm text-foreground-600 mb-8">
            您访问的页面不存在或已被移除
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-3-line"></i>
            返回首页
          </Link>
        </div>
      </div>
    </Layout>
  );
}